var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"100%","margin-bottom":"-4px"},attrs:{"src":require("../assets/app.jpg")}})}
var staticRenderFns = []

export { render, staticRenderFns }